<template>
  <div class="home_page">
    <!-- 轮播图 -->
    <img src="../assets/home/banner.png" alt="" />

    <div>
      <!-- 售卖价值 -->
      <div class="ad_sale"  style="padding: 100px 50px;">
        <div class="main_width">
          <!-- 标题 -->
          <div class="sub_title">
            <div class="line"></div>
            <h3>最大化流量售卖价值</h3>
            <div class="line"></div>
          </div>
          <!-- 卡片列表 -->
          <div class="ad_sale_detail">
            <div class="detail_item">
              <img src='../assets/home/sale1.png' />
              <div class="item_txt">全面支持RTB广告售卖模式(实时竞价)，支持广告位流量在线竞价、优先售卖。</div>
            </div>
            <div class="detail_item">
              <img src='../assets/home/sale2.png' />
              <div class="item_txt">基于广告和用户流量的大数据挖掘，建立预估模型，预测广告收益表现，智能匹配最具收益潜力的广告。</div>
            </div>
            <div class="detail_item">
              <img src='../assets/home/sale3.png' />
              <div class="item_txt">基于广告位，灵活配置广告平台之间或直投广告的投放优先级，随时将流量切换到变现效益最高的广告平台</div>
            </div>
            <div class="detail_item">
              <img src='../assets/home/sale4.png' />
              <div class="item_txt">提供自有广告，解决闲时流量浪费，保证广告位收益最大化。</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 广告形式 -->
      <div class="ad_type" style="padding: 50px 50px;">
        <!-- 标题 -->
        <div class="sub_title">
          <div class="line"></div>
          <h3>丰富的广告形式</h3>
          <div class="line"></div>
        </div>
        <!-- detail-->
        <div class="ad_type_detail">
          <!-- 轮播 -->
          <div class="detail_rotation" >
            <el-carousel
              height="465px"
              indicator-position="none"
              arrow="never"
              :interval="2000"
              ref="typeRotation"
              :autoplay="true"
              @change="typeRoChange"
              >
              <el-carousel-item>
                <img src="../assets/home/mobile1.png" alt="" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/home/mobile2.png" alt="" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/home/mobile3.png" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <!-- 文字 -->
          <div class="detail_text">
            <transition name="typeText" v-for="(item, i) in typeRotationList" :key="i" class="template-info">
              <div v-show="i === typeRotationIndex">
                <div class="title">{{item.title}}</div>
                <p>{{item.subtitle}}</p>
                <p>展现场景: {{item.content}}</p>
                <p>尺 寸: {{item.size}}</p>
                <p>支持平台: {{item.platform}}</p>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <!-- 自主接入 -->
    <div class="ad_access">
      <div class="main_width">
        <!-- 标题 -->
        <div class="sub_title">
          <div class="line"></div>
          <h3>高效率媒体自主接入</h3>
          <div class="line"></div>
        </div>

        <p>1n SDK的聚合功能，让您无需单独植入各平台SDK，只需正确配置优效SDK即可，不仅为您的媒体“瘦身”，也让您的流量在各平台之间流畅切换，及时抓住每一次高价值广</p>
        <!-- 卡片 -->
        <ul class="ad_access_detail">
          <li>
            <img src="../assets/home/sdk.png" alt="">
          </li>
          <li>
            <img src="../assets/home/api.png" alt="">
          </li>
        </ul>
      </div>
    </div>
    <!-- 流量价值 -->
    <div class="ad_value main_width">
      <!-- 标题 -->
      <div class="sub_title">
        <div class="line"></div>
        <h3>多维度透视流量价值</h3>
        <div class="line"></div>
      </div>
      <!-- detail -->
      <div class="ad_value_detail">
        <div>
          <img src="../assets/home/value1.png" alt="" >
          <p>媒体、广告位、广告形式、地域、时间、投放平台等全方位分析透视</p>
        </div>
        <div>
          <img src="../assets/home/value2.png" alt="">
          <p>实时监控、对比分析、智能提醒</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      typeRotationList: [
        {
          id: 1,
          title: 'Banner广告',
          subtitle: '适合在用户停留较久或者访问频繁的页面',
          content: '用户停留较久的页面用户访问比较频繁的页面',
          size: '640x100、480x75、320x50、240x38、936x120',
          platform: 'Android，iOS'
        },
        {
          id: 2,
          title: '开屏广告',
          subtitle: '应用开启后全屏展现的广告样式',
          content: '应用开启时',
          size: '640x960、320x480、640x1136',
          platform: 'Android，iOS'
        },
        {
          id: 3,
          title: '插屏广告',
          subtitle: '应用暂停或场景切换时以全屏、半屏的方式弹出',
          content: '视频前贴、暂停、后贴、游戏暂停、过关、阅读翻页、加载',
          size: '600x500、640x960',
          platform: 'Android，iOS'
        }
      ],
      typeRotationIndex: ''
    }
  },
  methods: {
    typeRoChange (newVal, oldVal) {
      this.typeRotationIndex = newVal
    },
    rotationPre () {
      // 切换到上一张
      this.$refs.typeRotation.prev()
    },
    rotationNext () {
      // 切换到下一张
      this.$refs.typeRotation.next()
    }

  }
}
</script>

<style lang="less" scoped>
.home_page{
  img{
    width: 100%;
    height: 100%;
  }
  .main_width {
    width: 1200px;
    margin: auto;
  }
  // 大轮播
  .home_rotation{
    .el-carousel--horizontal{
      overflow-x: visible;
    }
    .el-carousel__item {
      width: 100%;
      position: relative;
      overflow: hidden;
      height: 600px;
      img {
        width: 1920px;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
      }
    }
  }
  // 小标题
  .sub_title{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    h3 {
      font-size:36px;
      color:rgba(51,51,51,1);
      font-weight:500;
      margin: 0 19px;
    }
    .line {
      width: 60px;
      height: 4px;
      background-color: #9A2FEE;
    }
  }
  // 广告资源
  .ad_source{
    text-align: center;
    padding-top: 99px;
    .ad_source_text{
      font-size:22px;
      color: #999;
      margin: 0;
      font-weight: 400;
      span{
        color: #9A2FEE;
        font-size: 26px;
        font-weight: 500;
      }
    }
    img{
      margin-top: 63px;
      margin-bottom: 99px;
      width: 1200px;
      height: 317px;
    }
  }
  // 流量售卖
  .ad_sale{
    background-color: #F7F7F7;
    padding-top: 99px;
    padding-bottom: 74px;
    .ad_sale_detail{
      display: flex;
      justify-content: space-between;
      padding-top: 20px;
      .detail_item {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 43px;
        width: 260px;
        height: 390px;
        background-color: #fff;
        box-shadow: 0px 6px 20px 0px rgba(51,51,51,0.10);
        border-radius: 4px;
        img{
          margin: 70px 0 52px 0;
          width: 124px;
          height: 124px;
        }
        .item_txt{
          font-size: 14px;
          font-weight: 400;
          color: #333;
          text-align: center;
          line-height: 26px;
        }
      }
    }
  }
  // 广告形式
  .ad_type{
    padding-top: 99px;
    margin-bottom: 100px;
    .ad_type_detail{
      padding-top: 50px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .detail_rotation{
        position: relative;
        width: 365px;
        margin-left: 120px;
        span {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 60px;
          height: 60px;
          border-radius: 50%;
          img {
            border-radius: 50%;
          }
          &:hover {
            cursor: pointer;
          }
        }
        span:nth-of-type(1){
          left: -60px;
        }
        span:nth-of-type(2){
          right: -60px;
        }
      }
      .detail_text{
        margin-left: 140px;
        width: 580px;
        display: flex;
        h4{
          font-size:36px;
          font-weight:500;
          color: #333;
          margin: 0;
        }
        p {
          font-size:18px;
          font-weight:500;
          line-height:22px;
          color: #333333;
          margin: 0;
          word-wrap: normal;
          width: 580px;
          overflow: hidden;
        }
        p:nth-of-type(1) {
          margin: 20px 0 30px 0;
          color: #9A2FEE;
          font-size:20px;
          font-weight:500;
        }
        .template-info{
          width: 600px;
          margin-left: 20px;
        }
      }
      .typeText-enter {
        margin-left: 200px;
      }
      .title{
        font-size: 36px;
        font-weight: 700;
        line-height: 43px;
      }
    }
  }
  // 自主接入
  .ad_access{
    text-align: center;
    padding-top: 99px;
    padding-bottom: 100px;
    background-color: #F7F7F7;
    p{
      font-size: 22px;
      color: #333333;
      font-weight:500;
      padding: 0 4px;
      font-weight: 400;
      span {
        font-size: 26px;
        color: #9A2FEE;
        font-weight: 500;
      }
    }
    .ad_access_detail{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0;
      margin-top: 69px;
      li:nth-child(2) {
        margin-left: 99px;
      }
      li {
        list-style: none;
        width: 100%;
        img {
          width: 550px;
          height: 338px;
        }
      }
    }
  }
  // 流量价值
  .ad_value{
    text-align: center;
    margin-top: 99px;
    margin-bottom: 100px;
    .ad_value_detail{
      display: flex;
      justify-content: center;
      div{
        // width: 551px;
        // height: 270px;
        img {
          width: 551px;
          height: 270px;
        }
        p {
          font-size:18px;
          font-weight:400;
          line-height:26px;
          color: #333;
        }
      }
      div:nth-of-type(2) {
        margin-left: 99px;
      }
    }
  }

}
</style>
